<template>
  <span>
    <b-button
      id="show-btn"
      size="sm"
      :disabled="!cartItem.edit"
      block
      @click="openModal()"
      ><i class="fas fa-pencil"></i
    ></b-button>

    <b-modal
      id="add-to-cart"
      ref="cartmodal"
      size="lg"
      :title="cartItem.itemDescription"
      hide-footer
    >
      <b-form @submit="updateCartItem()" @submit.prevent>
        <b-form-group
          v-if="item.variants && item.variants.length > 0"
          id="variantGroup"
          :label="$t('variant2')"
          label-for="variant"
        >
          <b-form-select
            id="variant"
            v-model="cartItemForm.variantID"
            disabled
            :options="variantValuesToSelectOptions(item.variants)"
            required
          ></b-form-select>
        </b-form-group>
        <template v-for="option in itemOptions">
          <b-form-checkbox
            v-if="option.values.length === 1"
            :id="`${option.optionID}`"
            :key="option.optionID"
            v-model="cartItemForm[option.optionID]"
            :name="option.description"
            :value="option.values[0].optionValueID"
            :unchecked-value="null"
          >
            {{ option.description }}
          </b-form-checkbox>

          <b-form-group
            v-else
            :id="`${option.optionID}`"
            :key="option.optionID"
            :label="`${option.description}`"
            label-for="input-3"
          >
            <treeselect
              v-model="cartItemForm[option.optionID]"
              :required="option.required"
              :multiple="false"
              :disable-branch-nodes="true"
              :searchable="true"
              :show-count="true"
              :options="optionValuesToSelectOptions(option.values)"
            />
          </b-form-group>
        </template>

        <b-form-group
          id="amount-group"
          :label="$t('amount2')"
          label-for="amount"
        >
          <b-form-input
            id="amount"
            v-model="cartItemForm.qty"
            :placeholder="$t('amount3')"
            disabled
            required
          ></b-form-input>
        </b-form-group>

        <b-button v-if="processing" class="mt-3" block disabled
          ><i class="fas fa-spinner fa-spin"></i
        ></b-button>
        <hr />
        <b-button v-if="!processing" block type="submit"
          >{{ $t("modify") }}
        </b-button>
      </b-form>
    </b-modal>
  </span>
</template>

<script>
import api from "../../services/api"
import { patchCartItem } from "@/services/cart"
import store from "@/store/index"
import Treeselect from "@riophae/vue-treeselect"

import {
  BButton,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormSelect,
} from "bootstrap-vue"

export default {
  name: "ProductModalModifyCartItem",
  components: {
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    Treeselect,
  },
  props: {
    cell: {
      type: Object,
      required: true,
    },
    row: {
      type: Array,
      required: true,
    },
    cartItem: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      item: {},
      itemOptions: [],
      options: {},
      variant: "",
      person: "",
      qty: 1,
      processing: false,
      cartItemForm: {},
    }
  },
  computed: {
    persons: function () {
      return store.getters.persons
    },
    customerid: function () {
      return store.state.customerID
    },
    cartItems: function () {
      return store.state.cart.cartItems
    },
    selectedCartItem: function () {
      return this.cartItem
    },
    selectedVariantID: function () {
      return this.cartItemForm?.variantDescription
    },
  },
  watch: {
    cartItemForm: {
      handler: function (value) {
        this.options = {}

        if (!this.item.variants) return

        const variantOptions = this.item.variants?.find(
          (variant) => variant.id === value.variantID
        )?.options

        if (variantOptions)
          this.itemOptions = [...this.cartItem.options, ...variantOptions]
      },
      deep: true,
    },
    slectedCartItem: function (cartItem) {
      this.cartItemForm = cartItem
    },
    cartItem() {
      this.cartItemForm = this.selectedCartItem
    },
  },
  created: function () {
    this.cartItemForm = this.selectedCartItem

    const customerField = document.getElementsByName("customerid")

    store.commit("setCustomerID", { customerID: customerField[0].value })
  },
  methods: {
    async openModal() {
      if (!this.cartItem.edit) return
      if (Object.keys(this.item).length === 0) {
        // Only get item data if we do not already have it
        await this.getItemData()
      }
      if (this.item.variants.length < 1) {
        this.itemOptions = this.item.options
        this.options = this.item.options
      }

      console.log({ variants: this.item.variants })

      this.options = this.item.variants.find((variant) =>
        variant.description.includes(this.selectedVariantID)
      )?.options

      this.itemOptions = [
        ...this.item.variants.find((variant) =>
          variant.description.includes(this.selectedVariantID)
        ).options,
        ...this.item.options,
      ]
      this.showModal()
    },
    async showModal() {
      this.$refs.cartmodal.show("add-to-cart")
    },
    async getItemData() {
      const requestData = await api.get("/api/v1/items", {
        params: {
          ItemID: this.cartItem.itemID,
        },
      })

      this.item = requestData.data

      if (this.cartItem.variantDescription) {
        this.cartItemForm.variantID = this.item.variants.find((variant) =>
          variant.description.includes(this.cartItem.variantDescription)
        ).id
      }

      const variantOptions = this.item.variants?.find((variant) =>
        variant.description.includes(this.cartItemForm.variantDescription)
      )?.options

      if (variantOptions) {
        this.itemOptions = [...this.item.options, ...variantOptions]
        return
      }
      this.itemOptions = this.item.options
    },
    optionValuesToSelectOptions(optionValues) {
      const selectOptions = []
      for (const optionValue of optionValues) {
        let children = []

        // If we have childs add them to the children property
        if (optionValue.childs !== null && optionValue.childs.length > 0) {
          for (const childOptionValue of optionValue.childs) {
            children.push({
              label: childOptionValue.description,
              id: childOptionValue.optionValueID,
            })
          }
        }

        if (children.length === 0) {
          selectOptions.push({
            label: optionValue.description,
            id: optionValue.optionValueID,
          })
        } else {
          selectOptions.push({
            label: optionValue.description,
            id: optionValue.optionValueID,
            children,
          })
        }
      }
      return selectOptions
    },
    variantValuesToSelectOptions(variants) {
      const selectVariants = []
      for (const variant of variants) {
        selectVariants.push({
          text: variant.description,
          value: variant.id,
        })
      }
      return selectVariants
    },
    personValuesToSelectOptions(persons) {
      const selectPersons = []
      for (const person of persons) {
        selectPersons.push({
          text: person.name,
          value: person.dimensionObjectID,
        })
      }
      return selectPersons
    },
    async updateCartItem() {
      this.processing = true

      // Remove null values from object
      Object.keys(this.options).forEach((key) =>
        this.options[key] === null ? delete this.options[key] : {}
      )

      await patchCartItem({ cartItem: this.cartItemForm })
      await this.$refs["cartmodal"].hide()

      this.$toasted.show(
        `${this.item.description} ${this.$t("succesfullyModifiedCartItem")}`,
        {
          theme: "primary",
          position: "top-center",
          duration: 5000,
        }
      )

      store.dispatch("updateCart")

      this.processing = false
    },
  },
}
</script>
